import { useConvertFromPenceFactory } from "$routes/_lib/use-convert-currency";
import { makeStyles, TableCell, TableRow, Typography } from "@material-ui/core";
import format from "date-fns/format";
import { type PaymentMethod, TransactionType } from "elephant-web/gql";

export const formatTransactionType = (transactionType, paymentMethod) => {
  switch (transactionType) {
    // Transactions written before method capture have no payment method;
    // interpolating it regardless rendered "Payment (null)".
    case TransactionType.Payment:
      return paymentMethod ? `Payment (${paymentMethod})` : "Payment";
    case TransactionType.Exempt:
      return "Exempt";
    case TransactionType.Waiver:
      return "Waived";
    case TransactionType.ChargeInsurer:
      return "Insurer";
    case TransactionType.Refund:
      return "Refund";
    case TransactionType.Void:
      return "Void";
    default:
      return "Payment";
  }
};

const useStyles = makeStyles({
  cell: {
    fontSize: "14px",
  },
});
export const TransactionItem: FC<{
  key: string;
  cashier: { firstname?: string; middlename?: string; lastname?: string };
  date: string;
  amount: {
    value: number;
    currency: string;
  };
  transactionType: TransactionType;
  /** Either the raw enum (V1, from apollo) or a resolved display label (V2). */
  paymentMethod?: PaymentMethod | string;
}> = ({ cashier, date, amount, transactionType, paymentMethod }) => {
  const classes = useStyles();
  const penceToPounds = useConvertFromPenceFactory();

  const { firstname, middlename, lastname } = cashier;
  // Joining unconditionally left stray spaces around any absent part.
  const cashierName = [firstname, middlename, lastname]
    .filter(Boolean)
    .join(" ");
  return (
    <TableRow>
      <TableCell className={classes.cell}>{cashierName}</TableCell>
      <TableCell className={classes.cell}>
        {format(new Date(date), "dd/MM/yyyy HH:mm")}
      </TableCell>
      <TableCell>
        <Typography className={classes.cell}>
          {penceToPounds(amount?.value || 0).toFixed(2)}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography className={classes.cell}>
          {formatTransactionType(transactionType, paymentMethod)}
        </Typography>
      </TableCell>
    </TableRow>
  );
};
